export const green = () => {
	document.documentElement.style.setProperty('--color-bg', "#00FF00");
};

export const red = () => {
	document.documentElement.style.setProperty('--color-bg', "#FF0000");
};